<template>
	<el-container class="body-container">
		<LeftMenu v-if="$route.meta.showLeftMenu"></LeftMenu>
		<el-container class="main-container flex-item">
			<el-header :class="{bread: $route.meta.showBread}" v-if="$route.meta.showNav">
				<Nav></Nav>
				<Bread v-if="$route.meta.showBread"></Bread>
			</el-header>
			<el-main class="body-main" :class="{pad0: !$route.meta.showLeftMenu && !$route.meta.showNav}">
				<div class="container">
					<Content></Content>
				</div>
			</el-main>
			<el-footer class="main-footer center" height="30px">
				<a href="https://beian.mps.gov.cn/#/query/websearch?code=35021202000966" rel="noreferrer" target="_blank">闽公网安备 35021202000966号</a> / <a href="https://beian.miit.gov.cn/" target="_blank">备案号：闽ICP备18021136号-2</a>
			</el-footer>
		</el-container>
	</el-container>
</template>

<script setup lang="ts">
	import LeftMenu from "@/components/com/LeftMenu"
	import Nav from "@/components/com/Nav"
	import Bread from "@/components/com/Bread"
	import Content from "@/components/com/Content"
	import { useStore } from 'vuex'
	const {dispatch} = useStore()
	
	dispatch('publicOptions/getplatformInfo', 'needload')
	dispatch('publicOptions/getPersonInfo')
	// dispatch('publicOptions/getMenuList')
	
	const showBeian = location.origin.indexOf('www.xkgaoneng.cn') > -1
</script>

<style lang="scss">
	.body-container{
		height: 100vh;
		.el-header{
			padding: 0;
			--el-header-height: 50px;
			--bread-height: 55px;
			&.bread{
				--el-header-height: 105px;
			}
		}
	}
	.body-main{
		padding: 0 20px 10px 25px!important;
	}
	.container{
		background-color: #fff;
		border-radius: 5px;
		padding: 20px 30px;
	}
	.main-container{
		width: 100%;
		overflow-x: hidden;
	}
	.main-footer{
		font-size: 14px;
		line-height: 30px;
		position: relative;
	}
</style>
